export interface IMapSettings {
    MapProvider: MapProvider;
}

export enum MapProvider
{
    Google = 1,
    Yandex = 2
}